import { css } from 'styled-components';
export const BodyStyles = css `
    body {
        margin: 0;
    }
`;
//# sourceMappingURL=body-styles.js.map